import { render, staticRenderFns } from "./SidebarH.vue?vue&type=template&id=3f60150c"
import script from "./SidebarH.vue?vue&type=script&lang=js"
export * from "./SidebarH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports